import React from 'react';

import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';
import { FilterProvider } from 'src/components/common/filterProvider/FilterProvider';
import { OverviewSection } from 'src/components/OverviewSection';
import { date } from 'src/lib/date/date';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { OperationOverviewSection } from './OperationOverviewSection';
import { ServiceReportContent } from './ServiceReportContent';

interface ServiceReportProps {
  graphId: string;
  range: Parameters<typeof date.getDateBounds>[0];
  queryId?: string;
  isSubscription: boolean;
}

export const ServiceReport = ({
  range,
  queryId,
  graphId,
  isSubscription,
}: ServiceReportProps) => {
  const graphRef = useGraphRef();
  return (
    <FilterProvider>
      {({
        filter,
      }: {
        filter:
          | GraphQLTypes.ServiceErrorStatsFilter
          | GraphQLTypes.ServiceTracePathErrorsRefsFilter
          | GraphQLTypes.ServiceTraceRefsFilter
          | GraphQLTypes.ServiceQueryStatsFilter;
      }) => {
        // Ugh this is a bit of a hack, but relies on the fact that
        // FilterProvider always puts the schemaTag (variant) property
        // inside an "in" field.
        // @see https://github.com/mdg-private/studio-ui/blob/9098ff153fea03ad962d2c477d4a17464efa93f3/imports/ui/components/common/FilterProvider.tsx#L40
        // The alternative here is to pass in the whole filter to
        // OperationClientUsage but strip out any client filtering, which seems
        // non-trivial and not worth it right now.
        const hackilyObtainedGraphVariantFromFilter =
          filter.in?.schemaTag?.[0] ?? null;
        const isOperationLandingPage = !!(
          queryId && hackilyObtainedGraphVariantFromFilter !== null
        );

        return (
          <>
            <div className="@container">
              {isOperationLandingPage ? (
                <OperationOverviewSection
                  graphId={graphId}
                  graphVariant={
                    graphRef?.graphVariant ??
                    hackilyObtainedGraphVariantFromFilter
                  }
                  queryId={queryId}
                  range={range}
                  filter={filter}
                />
              ) : (
                <OverviewSection serviceId={graphId} filter={filter} />
              )}
            </div>
            <div className="mt-8 flex flex-col gap-6">
              <ServiceReportContent
                filter={filter}
                range={range}
                queryId={queryId}
                graphId={graphId}
                isOperationLandingPage={isOperationLandingPage}
                isSubscription={isSubscription}
              />
            </div>
          </>
        );
      }}
    </FilterProvider>
  );
};
